import { capitalizarPalabras } from "../sharedFunctions";

/**
 * Devuelve el nombre formateado del solicitante de una propuesta V2.
 * Si la propuesta no tiene solicitante asignado, devuelve "cliente" como fallback.
 */
export function obtenerNombreDestinatario(propuesta) {
  const raw =
    propuesta?.solicitante?.nombre || propuesta?.nombreSolicitante || "";
  return raw ? capitalizarPalabras(raw) : "cliente";
}

/**
 * Devuelve el correo de contacto del vendedor responsable.
 * Fallback generico "tu vendedor" si no hay correo asociado.
 */
export function obtenerCorreoContactoVendor(propuesta) {
  return propuesta?.vendedorCorreo || "tu vendedor";
}
